export const meta = {
  title: '可接受使用政策 | Hotel Lobby AI',
  description:
    'Hotel Lobby AI 内容规则：未成年人保护、禁止的 AI 内容、深度伪造与冒充、提示词安全审核，以及违规内容举报方式。',
  updated_at: '2026-10-03',
};

## 目的

Hotel Lobby AI 会根据上传的照片生成真实人物的 AI 图像和视频。本政策规定您可以和不可以制作的内容。本政策是我们[《服务条款》](/zh/terms-of-service)的组成部分，适用于所有照片、风格说明和生成结果。

## 儿童安全：零容忍

我们对儿童性虐待材料（CSAM）以及任何性化、剥削或危害未成年人的内容零容忍。

- 严禁上传、请求或生成涉及 18 岁以下人士（或看起来未满 18 岁的人）的色情、性暗示、裸露或衣着暴露内容，包括 AI 生成、绘制或"虚构"的未成年人。
- 严禁利用本服务诱骗、骚扰、羞辱或危害儿童，或将儿童置于暴力、侮辱或危险的场景中。
- 未满 18 岁人士的照片只能由其父母或法定监护人上传，且仅限用于正常、健康的家庭内容。

任何疑似 CSAM 的内容都会被立即删除，相关账户将被永久终止，相关数据将依法保留，我们会向美国国家失踪与受虐儿童中心（NCMEC）和/或相关执法部门报告。

## 禁止的内容

您不得使用 Hotel Lobby AI 制作、请求或分享以下内容：

- **任何形式的色情或私密内容**，包括裸露、性行为、性化姿势，或对照片中的人物进行"脱衣"处理。
- **未经同意的私密影像**，无论是真实的还是合成的。
- **未经本人同意的深度伪造内容。** 只能上传您本人或已获得其许可的人的照片。
- **冒充他人**，包括让真实人物、品牌或公众人物看起来说了或做了其从未说过、做过的事，或将内容用于诈骗、欺诈或虚假代言。
- **骚扰、霸凌、仇恨或威胁**，针对个人或群体，包括基于受保护特征嘲讽或贬低他人的内容。
- **暴力、自残或极端主义内容**，包括血腥内容以及宣扬恐怖主义或暴力极端主义的内容。
- **违法内容**，或侵犯著作权、商标权、隐私权或肖像权的内容。
- **意图欺骗的虚假信息**，例如伪造的新闻画面或与选举相关的欺骗内容。

## 安全措施与提示词审核

- 每一段可选的风格说明在生成前都会先经过我们自己的过滤器和自动化提示词安全扫描服务的审核。被标记的请求会在生成任何图像或视频之前被拒绝。
- 我们的 AI 服务商也会对图像和视频执行各自的安全过滤。
- 我们可能审核内容、拒绝任何请求，并删除违反本政策的生成内容。
- 请勿尝试绕过上述措施，例如使用错别字、暗语或其他技巧。试图规避安全机制本身即构成违规。

## 举报违规内容

如果您发现使用 Hotel Lobby AI 生成的内容违反本政策，或认为您的肖像在未经同意的情况下被使用，请举报：

- **邮件：** 发送至 [support@hotel-lobby.org](mailto:support@hotel-lobby.org)，邮件标题注明"Abuse report（违规举报）"。
- **已登录用户：** 也可以在 **设置 → 工单支持** 中提交工单。
- **请提供：** 内容的链接或截图、发现位置，以及违反本政策的原因。如内容中的人物是您本人，请说明，我们会优先处理当事人的举报。

**处理时限：**

- **儿童安全（CSAM）举报：** **24 小时内**处理：删除内容、终止账户并向有关部门报告。
- **涉及举报人本人的未经同意私密影像或深度伪造：** 收到有效举报后 **48 小时内**删除内容。
- **其他所有举报：** **2 个工作日内**确认收到，**7 天内**处理完毕。

我们不会向被举报用户透露举报人身份。如果您的内容被删除且您认为处理有误，可在 30 天内回复我们的通知或发送邮件至客服申诉。

## 违规处理

根据违规的严重程度，我们可能拒绝或删除相关内容、发出警告、暂停或永久终止账户，并作废剩余积分且不予退款，具体见[《服务条款》](/zh/terms-of-service)。我们会配合执法部门，并依法报告违法内容。

## 变更

我们可能随服务和法律的变化更新本政策，修订日期见页首。
